"use strict";

exports.__esModule = true;
exports.RealtimeConnectionContext = void 0;
var _Utils = require("../../../Utils");
var _RealtimeConnectionController = require("./RealtimeConnectionController");
/**
 * Makes a realtime connection available to consumers.
 * @component
 */
var RealtimeConnectionContext = exports.RealtimeConnectionContext = (0, _Utils.createEnhancedContext)({
  propName: "realtime",
  defaultController: _RealtimeConnectionController.RealtimeConnectionController
});